import { render, staticRenderFns } from "./SktFree5000.vue?vue&type=template&id=028cf8ca&scoped=true"
import script from "./SktFree5000.vue?vue&type=script&lang=js"
export * from "./SktFree5000.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "028cf8ca",
  null
  
)

export default component.exports